import {PIXI} from '@colonist/pixi'
import {UIGameToolTipController} from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipController'
import {UIMGameToolTipView} from './UIMGameToolTipView'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameToolTipView} from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipView'
import {isDescendantOf} from '../../../../shared/scripts/ui_utils/PixiUtils'
import {TimeoutId} from '@colonist/types'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

export class UIMGameToolTipController extends UIGameToolTipController {
    private readonly uiGameManager: UIGameManager
    private pointerDownPosition: PIXI.Point

    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)
        this.uiGameManager = uiGameManager
    }

    createTip(toolTipText: ToolTipText, view: PIXI.Container): void {
        this.addTooltipEvent(() => this.openTip(toolTipText, view), view)
    }

    override disableTip(view: PIXI.Container) {
        super.disableTip(view)
        view.off('tap')
        const mapView = this.uiGameManager.mapController.mapView
        mapView.off('touchstart')
    }

    openTip(toolTipText: ToolTipText, view: PIXI.Container) {
        this.closeTip()
        const {title, body} = toolTipText()
        if(clientI18n.t(title.key, title.options) == '' && clientI18n.t(body[0].key, body[0].options) == '') return
        if(!isDescendantOf(view, this.app.stage)) return
        this.tip = new UIMGameToolTipView(view, title, body)
    }

    createTipFromTooltipView(getTooltipView: () => UIGameToolTipView, view: PIXI.Container) {
        this.addTooltipEvent(() => this.tip = getTooltipView(), view)
    }

    private addTooltipEvent(createTooltip: () => void, view: PIXI.Container) {
        const timeoutToOpenTooltipMillis = 500
        let tooltipEvent: TimeoutId | undefined
        view.interactive = true
        view.addListener('pointerdown', (e: PIXI.FederatedPointerEvent) => {
            this.pointerDownPosition = new PIXI.Point(e.global.x, e.global.y)
            tooltipEvent = setTimeout(() => {
                createTooltip()
            }, timeoutToOpenTooltipMillis)
        })
        const tolerance = 20
        view.addListener('pointermove', (e: PIXI.FederatedPointerEvent) => {
            if(tooltipEvent == undefined) return
            const mousePosition = e.global
            if(Math.abs(mousePosition.x - this.pointerDownPosition.x) > tolerance || Math.abs(mousePosition.y - this.pointerDownPosition.y) > tolerance) {
                clearTimeout(tooltipEvent)
                tooltipEvent = undefined
                this.closeTip()
            }
        })
        view.addListener('pointerup', () => {
            clearTimeout(tooltipEvent)
        })

        const mapView = this.uiGameManager.mapController.mapView
        mapView.on('pointerdown', (event: PIXI.FederatedPointerEvent) => this.closeTip())
    }
}
